import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOTCOURSE",
    applicationRights: Rights,
    title: 'Kurs',
    text: 'Kurs',
    icon: 'graduation-cap',
    url: "/course/pilot",
    mobileThreshold: 1024,
    sequenceNo: 14000,
    routes: Routes
})
